import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Campo de contraseña con botón para mostrar/ocultar el texto.
 * Unifica el patrón en Login, Register, ResetPassword y cambio de contraseña
 * para que la experiencia sea consistente en toda la plataforma.
 *
 * Acepta las mismas props que un <input> (value, onChange, required, placeholder…).
 */
export default function PasswordInput({ className = '', ...props }) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative">
      <input
        {...props}
        type={visible ? 'text' : 'password'}
        className={`w-full pr-11 ${className}`}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? t('auth.hidePassword', 'Ocultar contraseña') : t('auth.showPassword', 'Mostrar contraseña')}
        title={visible ? t('auth.hidePassword', 'Ocultar contraseña') : t('auth.showPassword', 'Mostrar contraseña')}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-gray-400 hover:text-[#134168] transition-colors"
      >
        {visible ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
      </button>
    </div>
  );
}
